import { jsx as _jsx } from "react/jsx-runtime";
import { Circle as _Circle } from "react-leaflet"; // Todo: MHC-00783 react-leaflet v4 has some typescript errors https://trello.com/c/U7DFYEIA
const Circle = _Circle;
export const MapCircle = (props) => {
    const { center, radiusInMeters, color = 'red', opacity = 1, fill = true, fillColor = 'red', fillOpacity = 0.3, } = props;
    return (_jsx(Circle, { center: center, radius: radiusInMeters, color: color, opacity: opacity, fill: fill, fillColor: fillColor, fillOpacity: fillOpacity }));
};
